/* eslint-disable no-tabs */
/* eslint-disable multiline-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import { Icon, Dropdown, Menu, Button } from '@tinper/next-ui';

function CardTableOperations (props) {
  const { operationItems: operationItemsProp, operationItemsMaxCount, record, index, operationType, operationClick, fieldid } = props;

  const operationItems = typeof operationItemsProp === 'function' ? operationItemsProp(record) : operationItemsProp;

  const operationItemsInline = operationItems.slice(0, operationItemsMaxCount);
  const isMoreMaxCount = operationItems.length > operationItemsMaxCount;
  const getMenusItems = (items) => {
    return items.map((item, index) => {
      return {
        key: index,
        label: item.text,
        onClick: ({ domEvent }) => {
          domEvent.stopPropagation();
          operationClick(record, item, domEvent, props.index)
        }
      }
    })
  }
  const otherOperationItems = operationItems.slice(operationItemsMaxCount);
  const menusItems = getMenusItems(otherOperationItems);

  const menus = (<Menu items={menusItems} fieldid={`${fieldid}_operations_dropdown_menu`}></Menu>);

  return (<div className='opt-btns'>
    <div style={{ display: 'inline-block' }}>
      {
        operationItemsInline.map(item => {
          return <Button
            type={operationType}
            size='sm'
            style={{ marginRight: '5px' }}
            onClick={(e) => {
              e.stopPropagation();
              operationClick(record, item, e, index)
            }}
            fieldid={`${fieldid}_operations_item_${item.key}`}
            {...(item.otherProps || {})}>
            {item.text}
          </Button>
        })
      }
    </div>

    {isMoreMaxCount ? <Dropdown overlay={menus} getPopupContainer={(ele) => ele.parentElement} fieldid={`${fieldid}_operations_dropdown`}>
      {/* { */}
      {/*	operationType === 'button' ? */}
      {/*		<Button size='sm'  style={{ marginRight: '5px' }} bordered={true} icon={<Icon type="uf-ellipsis" />}></Button>: */}
      {/*		<Icon type="uf-ellipsis" /> */}
      {/* } */}
      <Button
        size='sm'
        style={{ marginRight: '5px', border: operationType === 'button' ? '' : 'none' }}
        icon={<Icon type="uf-ellipsis" />}
        fieldid={`${fieldid}_operations_dropdownbtn`}
      ></Button>
    </Dropdown> : null }
  </div>);
}

export default CardTableOperations;
